export const supportedLanguages = {
  'en-gb': 'en-gb',
  'en-us': 'en-us',
  de: 'de',
  es: 'es',
  pt: 'pt',
};

export type SupportedLanguage = keyof typeof supportedLanguages;
